import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AddExpense from "@/pages/AddExpense";
import Expenses from "@/pages/Expenses";
import Sites from "@/pages/Sites";
import HomeDetail from "@/pages/HomeDetail";
import Budgets from "@/pages/Budgets";
import Reports from "@/pages/Reports";
import Reconciliation from "@/pages/Reconciliation";
import Audit from "@/pages/Audit";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";

const P = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function LoginRoute() {
  const { user } = useAuth();
  if (user) window.location.replace("/");
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<P><Dashboard /></P>} />
            <Route path="/add" element={<P><AddExpense /></P>} />
            <Route path="/expenses" element={<P><Expenses /></P>} />
            <Route path="/sites" element={<P><Sites /></P>} />
            <Route path="/sites/:id" element={<P><HomeDetail /></P>} />
            <Route path="/budgets" element={<P roles={["admin", "manager"]}><Budgets /></P>} />
            <Route path="/reports" element={<P roles={["admin", "manager"]}><Reports /></P>} />
            <Route path="/reconcile" element={<P roles={["admin", "manager"]}><Reconciliation /></P>} />
            <Route path="/audit" element={<P roles={["admin", "manager"]}><Audit /></P>} />
            <Route path="/users" element={<P roles={["admin"]}><Users /></P>} />
            <Route path="/settings" element={<P roles={["admin"]}><Settings /></P>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
